// Help page components
import { Calculator, Clock, Calendar, Briefcase, FileText, Settings } from 'lucide-react';

export function HelpSection({ icon: Icon, title, children }) {
  return (
    <div className="border border-border rounded-lg bg-card overflow-hidden">
      <div className="bg-primary/10 px-4 py-3 flex items-center gap-2 border-b border-border">
        <Icon className="h-5 w-5 text-primary" />
        <h2 className="font-semibold text-lg">{title}</h2>
      </div>
      <div className="p-4 space-y-3">
        {children}
      </div>
    </div>
  );
}

export function FormulaBox({ title, formula, example }) {
  return (
    <div className="bg-muted/50 rounded-lg p-3 space-y-2">
      <p className="font-medium text-sm">{title}</p>
      <code className="block bg-background px-3 py-2 rounded text-sm font-mono text-primary">
        {formula}
      </code>
      {example && (
        <p className="text-xs text-muted-foreground italic">{example}</p>
      )}
    </div>
  );
}

export function InfoItem({ label, value }) {
  return (
    <div className="flex justify-between py-1 border-b border-border/50 last:border-0">
      <span className="text-sm text-muted-foreground">{label}</span>
      <span className="text-sm font-medium">{value}</span>
    </div>
  );
}

export function HelpList({ items }) {
  return (
    <ul className="space-y-2">
      {items.map((item, i) => (
        <li key={i} className="text-sm text-muted-foreground flex items-start gap-2">
          <span className="text-primary">•</span> {item}
        </li>
      ))}
    </ul>
  );
}

export { Clock, Calendar, Briefcase, Calculator, FileText, Settings };
